import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Table, TableBody } from 'shared/mui/Table';
import { TotalOrders } from 'types/embedded/orderConversion';

import { StyledCard, StyledCardHeader } from './OrderConversionListOrders.styled';
import { OrderConversionListOrdersTableRow } from './OrderConversionListOrdersTableRow/OrderConversionListOrdersTableRow';

type Props = {
  orders: TotalOrders | undefined;
};

export const OrderConversionListOrders: React.FC<Props> = ({ orders }) => {
  const translate = useTypedTranslate();
  const {
    orderCount = 0,
    success = 0,
    failure = 0,
    cancelled = 0,
    expired = 0,
    pending = 0,
    prepared = 0,
    created = 0,
    refund = 0,
    chargeback = 0,
    groups: { failureGroup = 0, pendingGroup = 0, successGroup = 0 } = {},
  } = orders || {};

  return (
    <StyledCard>
      <StyledCardHeader
        title={translate('app.orderConversion.orderConversionListOrdersTitle')}
        titleSize="smallBold"
      />
      <Table>
        <TableBody>
          <OrderConversionListOrdersTableRow
            contentStyle={{
              borderBottom: '1px solid',
              borderColor: 'divider',
              padding: '6px 16px',
            }}
            headerStyle={{
              fontWeight: 500,
              padding: '6px 16px',
              borderBottom: '1px solid',
              borderColor: 'divider',
            }}
            label={translate('app.orderConversion.countLabels.orderCount')}
            value={orderCount}
          />
          <OrderConversionListOrdersTableRow
            contentStyle={{
              padding: '14px 16px 4px',
            }}
            headerStyle={{
              fontWeight: 500,
              padding: '14px 16px 4px',
            }}
            label={translate('app.orderConversion.countLabels.success')}
            status="success"
            value={successGroup}
          />
          <OrderConversionListOrdersTableRow
            label={translate('app.orderConversion.countLabels.success')}
            value={success}
          />
          <OrderConversionListOrdersTableRow
            headerStyle={{ fontWeight: 500 }}
            label={translate('app.orderConversion.countLabels.failure')}
            status="failure"
            value={failureGroup}
          />
          <OrderConversionListOrdersTableRow
            label={translate('app.orderConversion.countLabels.failure')}
            value={failure}
          />
          <OrderConversionListOrdersTableRow
            label={translate('app.orderConversion.countLabels.cancelled')}
            value={cancelled}
          />
          <OrderConversionListOrdersTableRow
            label={translate('app.orderConversion.countLabels.expired')}
            value={expired}
          />
          <OrderConversionListOrdersTableRow
            headerStyle={{ fontWeight: 500 }}
            label={translate('app.orderConversion.countLabels.pending')}
            status="pending"
            value={pendingGroup}
          />
          <OrderConversionListOrdersTableRow
            label={translate('app.orderConversion.countLabels.pending')}
            value={pending}
          />
          <OrderConversionListOrdersTableRow
            label={translate('app.orderConversion.countLabels.created')}
            value={created}
          />
          <OrderConversionListOrdersTableRow
            label={translate('app.orderConversion.countLabels.prepared')}
            value={prepared}
          />
          <OrderConversionListOrdersTableRow
            headerStyle={{ fontWeight: 500 }}
            label={translate('app.orderConversion.countLabels.refund')}
            value={refund}
          />
          <OrderConversionListOrdersTableRow
            headerStyle={{ fontWeight: 500 }}
            label={translate('app.orderConversion.countLabels.chargeback')}
            value={chargeback}
          />
        </TableBody>
      </Table>
    </StyledCard>
  );
};
